import { IconButton, useTheme, Box } from '@mui/material';
import { IoShareSocial } from 'react-icons/io5';

export default function ShareButton({ handleShare }) {
  return (
    <IconButton
      onClick={handleShare}
    >
      <IoShareSocial
        style={{
          width: '20px',
          height: '20px',
        }}
      />
    </IconButton>
  );
}
